import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-voice.tsx
/**
* icon.24.voice
*
* Keywords: waveform, audio, sound, frequency, equalizer, vertical, bars, music
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjUgNWEuNS41IDAgMCAxIC41LjV2MTNhLjUuNSAwIDAgMS0xIDB2LTEzYS41LjUgMCAwIDEgLjUtLjVtMyAxYS41LjUgMCAwIDEgLjUuNXYxMWEuNS41IDAgMCAxLTEgMHYtMTFhLjUuNSAwIDAgMSAuNS0uNW0tNiAyYS41LjUgMCAwIDEgLjUuNXY3YS41LjUgMCAwIDEtMSAwdi03YS41LjUgMCAwIDEgLjUtLjVtOSAxYS41LjUgMCAwIDEgLjUuNXY1YS41LjUgMCAwIDEtMSAwdi01YS41LjUgMCAwIDEgLjUtLjVtLTEyIDFhLjUuNSAwIDAgMSAuNS41djNhLjUuNSAwIDAgMS0xIDB2LTNhLjUuNSAwIDAgMSAuNS0uNSIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=8365-9635
*/
const Icon24Voice = memo(function Icon24Voice(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.5 5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5m3 1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5m-6 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5m9 1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5m-12 1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5"
		})
	});
});
//#endregion
export { Icon24Voice };

//# sourceMappingURL=icon-24-voice.js.map